module.exports = __webpack_public_path__ + "static/img/sl-banner-h5.5d55dd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sl-banner-h5.png
// module id = zauB
// module chunks = 34